import { memo } from 'react'

import { Apartment, Person, Groups } from '@mui/icons-material'

import { Chip, ChipProps } from '@collaborate-health/uikit'
import { CertificateScopeType } from '@tabeeb/contracts/microservices/swagger-certificate-service'
import { CertificateScopeTypeDisplayName } from '../../enums'

const CertificateScopeToColorMap: Record<CertificateScopeType, ChipProps['color']> = {
  [CertificateScopeType.ProfileCertificate]: 'default',
  [CertificateScopeType.UserCertificate]: 'info',
  [CertificateScopeType.TenantCertificate]: 'primary',
}

const CertificateScopeToIconMap: Record<CertificateScopeType, ChipProps['icon']> = {
  [CertificateScopeType.ProfileCertificate]: <Person />,
  [CertificateScopeType.UserCertificate]: <Groups />,
  [CertificateScopeType.TenantCertificate]: <Apartment />,
}

export interface CertificateScopeChipProps {
  scope: CertificateScopeType
  fontSize?: string
}

const CertificateScopeChip: React.FC<CertificateScopeChipProps> = ({ scope }) => {
  const color = CertificateScopeToColorMap[scope] || 'default'
  const icon = CertificateScopeToIconMap[scope]

  return <Chip label={CertificateScopeTypeDisplayName[scope]} size='small' color={color} icon={icon} />
}

export default memo(CertificateScopeChip)

